<select
  class="form-select tas-form-control bg-white"
  [name]="jsonControl.name"
  [id]="jsonControl.id"
  [attr.aria-describedby]="'helpId-' + jsonControl.id"
  [required]="jsonControl.field.required ?? true"
  [formControl]="control"
>
  <option value="" *ngIf="jsonControl.field.placeholder" disabled selected>
    {{ jsonControl.field.placeholder }}
  </option>
  <option *ngFor="let opcion of opciones" [value]="opcion.value">
    {{ opcion.label }}
  </option>
</select>